import React from "react";
import styled from "styled-components";

const parse = (str) => {
  try {
    const d = new Date(str);
    const months = ["ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DEC"];
    return { day: d.getDate(), month: months[d.getMonth()], year: d.getFullYear() };
  } catch {
    return { day: "—", month: "", year: "" };
  }
};

const Calendar = ({ events, filterEvents }) => {
  const now = new Date(new Date().setHours(0, 0, 0, 0));
  const filter = !!filterEvents;

  const filtered = filter
    ? events.filter((e) => {
        const d = new Date(new Date(e.date).setHours(0, 0, 0, 0));
        return d.getTime() >= now.getTime();
      })
    : [...events];

  filtered.sort(
    (a, b) => new Date(a.date).setHours(0, 0, 0, 0) - new Date(b.date).setHours(0, 0, 0, 0)
  );

  if (filtered.length === 0) return <Empty>La liga ha terminado</Empty>;

  return (
    <Track>
      {filtered.map((event, idx) => {
        const d = new Date(new Date(event.date).setHours(0, 0, 0, 0));
        const isToday = d.getTime() === now.getTime();
        const { day, month } = parse(event.date);
        return (
          <Entry key={idx} $today={isToday}>
            <HeroNum>{day}</HeroNum>
            <BodyBlock>
              <MonoRow>
                <MonthLabel>{month}</MonthLabel>
                {isToday && <TodayBadge>HOY</TodayBadge>}
              </MonoRow>
              <NameText>{event.name}</NameText>
            </BodyBlock>
          </Entry>
        );
      })}
    </Track>
  );
};

const Track = styled.div`display: flex; flex-direction: column; gap: 1px;`;

const Entry = styled.div`
  display: flex; align-items: center; gap: 1.25rem;
  background: ${({ $today }) => $today ? "rgba(60,255,208,0.04)" : "transparent"};
  border: 1px solid ${({ $today }) => $today ? "rgba(60,255,208,0.12)" : "transparent"};
  border-radius: 16px; padding: 0.6rem 1rem;
  transition: background 0.15s ease;
`;

const HeroNum = styled.span`
  font-family: Anton, sans-serif; font-size: 44px; font-weight: 400; line-height: 1;
  color: var(--v-fg); min-width: 2.6rem; text-align: center; flex-shrink: 0;
  letter-spacing: -0.02em;
`;

const BodyBlock = styled.div`display: flex; flex-direction: column; gap: 0.2rem; flex: 1; min-width: 0;`;

const MonoRow = styled.div`display: flex; align-items: center; gap: 0.5rem;`;

const MonthLabel = styled.span`
  font-family: var(--v-font-mono); font-size: 9px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.5px; color: var(--v-fg-muted);
`;

const TodayBadge = styled.span`
  font-family: var(--v-font-mono); font-size: 8px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.5px;
  color: #000; background: var(--v-mint);
  padding: 0.15rem 0.45rem; border-radius: 6px; line-height: 1.2;
`;

const NameText = styled.span`
  font-family: var(--v-font-body); font-size: 15px; font-weight: 500;
  color: var(--v-fg); line-height: 1.3;
`;

const Empty = styled.p`font-family: var(--v-font-body); font-size: 13px; color: var(--v-fg-muted); margin: 0;`;

export default Calendar;
